import { Outlet } from "react-router-dom";
import { Container, Box, Alert } from "@mui/material";

import logo from "../../assets/images/logoPreferencial.svg";
import Snackbar from "../../components/Snackbar";

function Auth() {
  return (
    <Container
      maxWidth={false}
      sx={{
        background: `#181d3a`,
      }}
    >
      <Container
        sx={{
          display: "flex",
          height: "100vh",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { xs: 400, lg: 500 },
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            borderRadius: "1em",
            border: "2px solid #FFF",
            padding: { xs: "2em", lg: "3em 4em" },
            textAlign: "center",
          }}
        >
          <img
            src={logo}
            width="120"
            style={{ marginBottom: "40px" }}
            alt="Atlântico Digital"
          ></img>
          <Outlet />
        </Box>
      </Container>
      <Snackbar />
    </Container>
  );
}

export default Auth;
